import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Role } from '../../models/User';
import { ReportService } from '../../services/report.service';
import { Report, ReportType, ReportRole } from '../../models/Report';
import { AccountService } from '../../services/account.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuService } from '../../services/menu.service';
import { MenuRole, Menu } from '../../models/CommonModels';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-report-role-config',
  templateUrl: './report-role-config.component.html',
  styleUrls: ['./report-role-config.component.css']
})
export class ReportRoleConfigComponent implements OnInit {

  public roles: Role[] = [];
  public reports: Report[];
  public activeTab: string;
  public roleReports: ReportRole[] = [];
  public reportTypes: ReportType[] = [];
  public selectedRoleId: number;
  public activeReports: Report[] = [];
  public menus: Menu[];
  public menuRoles: MenuRole[] = [];

  constructor(private userService: UserService, private reportService: ReportService, private accountService: AccountService, 
    private spinner: NgxSpinnerService, private menuService: MenuService, private alertService: AlertService) { }

  ngOnInit() {
    this.getUserRoles();
    this.getAllReportTypes();
    this.getMenus();

    this.activeTab = 'Report';

    (<any>jQuery('#metismenu')).metisMenu();
    $(document).ready(function(){
      $('.i-checks').iCheck({ checkboxClass: 'icheckbox_square-green'});
      $('.i-checks').on('ifToggled', event => {
      });
    });  
  }

  getUserRoles(){
    this.userService.getRoles().subscribe(
      resp => {
        this.roles = resp;
        this.displayConfigForSelection(this.roles[0]);
      }
    );
  }

  isActiveTab(tabLabel) {
    return this.activeTab === tabLabel;
  }

  tabSelected(tabLabel) {
    this.activeTab = tabLabel;  
  }

  displayConfigForSelection(role){
    this.selectedRoleId = role.id;
    this.getReportByRole(role.id);
    this.getMenuByRole(role.id);
  }

  isActive(roleID) {
      return this.selectedRoleId === roleID;
  }

  getAllReportTypes(){
    this.reportService.getAllReports().subscribe(
      resp=>{
        this.reportTypes = resp.map(r => r.reportType);
        this.reportTypes = this.reportTypes.filter((item, index) => this.reportTypes.findIndex(r => r.id == item.id) == index);
        this.reportTypes.forEach(reportType => {
          reportType.reports = resp.filter(r => r.reportTypeID == reportType.id);
        });    
    })
  }

  getReportByRole(id){
    this.reportService.getReportByRole(id).subscribe(
      resp=>{
      this.roleReports = resp;
      this.reportTypes.forEach(repTyp =>{
        repTyp.reports.forEach(report => {
          if(this.roleReports.findIndex(r => r.reportID === report.id) > -1){
            report.checked = true;
          }else {
            report.checked = false;
          }
        });
      })

    })
  }

  reportCheckboxChanged(report) {
    this.spinner.show();
    report.checked = !report.checked;
    let reportRole = new ReportRole();
    reportRole.roleID = this.selectedRoleId;
    reportRole.reportID = report.id;
    if(report.checked){
      this.reportService.addReportRole(reportRole).subscribe(resp=>{
        this.getReportByRole(this.selectedRoleId)
        this.spinner.hide();
      })  
    }else{
      const id = this.roleReports.find(rp => rp.reportID === report.id).id;
      this.reportService.unlinkReportRole(id).subscribe(resp=>{
        this.getReportByRole(this.selectedRoleId);
        this.spinner.hide();
      }) 
    }  
  }

  reportChecklistClicked(report){
    if(report.checked){
      console.log(report.checked)
    }
  }

  reportIsActive(report) {
    return this.roleReports.findIndex(r => r.reportID == report.id) > -1;
  }

  getReportForTheSelectedRole(report){
    console.log(report);
  }

  navMenuClicked(value) {
    value.isExpanded = !value.isExpanded;  
  }

  getMenus(){
    this.menuService.getMenus().subscribe(
      resp=> {
        this.menus = resp;
        this.menus.forEach(menu => {
          menu.childMenus = this.menus.filter(m => m.parentMenuID == menu.id);
        });
        this.menus = this.menus.filter(m => m.parentMenuID == null);
      }
    );
  }

  menuIsActive(menu){
    return this.menuRoles.findIndex(m => m.menuID == menu.id) > -1;
  }

  getMenuByRole(id){
    this.menuService.getMenuByRole(id).subscribe(
      resp=>{
      this.menuRoles = resp;
      this.menus.forEach(menu =>{
          this.changeCheckboxStatus(menu);
          menu.childMenus.forEach(childMenu => {
            this.changeCheckboxStatus(childMenu);
          });
      });
    })
  }

  menuCheckboxChanged(menu) {
    this.spinner.show();
    menu.checked = !menu.checked;
    if(menu.checked){
      let menuRole = new MenuRole();
      menuRole.roleID = this.selectedRoleId;
      menuRole.menuID = menu.id;
      this.menuService.addMenuRole(menuRole).subscribe(resp=>{
        this.getMenuByRole(this.selectedRoleId)
        this.spinner.hide();
        this.alertService.success('Menu Configuration Changed, Log out and Login to see changes');
      })  
    }else{
      const id = this.menuRoles.find(m => m.menuID === menu.id).id;
      this.menuService.unlinkMenuRole(id).subscribe(resp=>{
        this.getMenuByRole(this.selectedRoleId);
        this.spinner.hide();
        this.alertService.success('Menu Configuration Changed, Log out and Login to see changes');
      }) 
    }  
  }

  changeCheckboxStatus(menu){
    if(this.menuRoles.findIndex(m=> m.menuID === menu.id) > -1){
      menu.checked = true;
    }else {
      menu.checked = false;
    }
  }
}
